import { FeatureToggleClientService } from 'feature-toggle-client';
export const disableRedundantConsumers = 'analytics-disable-redundant-consumers';
export class MetricsFeatures {
    static async isEnableMetricsToStatistics() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(disableRedundantConsumers);
    }
}
